export default (sizeInBytes) => (sizeInBytes / (1024 * 1024)).toFixed(2);
